import store from '../store'
import shared from './shared'
import devApi from './dev/api'
import preApi from './pre/api'
import onlineApi from './online/api'
const tmp = {
  api: {}
}
// dev
if (__DEV__) {
  tmp.BASE_URL = '' // 跳转到老系统的域名
  tmp.CORPORATION_MAIN_URL = 'http://b12013.camcard.com'
  tmp.CAMCARD_MAIN_URL = 'http://w12013.camcard.com'
  tmp.CORPORATION_STATIC_URL = 'http://static12013.intsig.net'
  tmp.FLOGGER_URL = 'https://web-ubd-sandbox.intsig.net/'
  tmp.api_default = devApi
  tmp.env = 'dev'
  tmp.STRIPE_KEY =
    'pk_test_51JV5f5BlhvsvhMM2qdk3hOhY9x7UgJNfqERYJYVbQ8bkgUzm90nw9dpzDDHO4fMe175TZONfezMRm3vTcuk9dHCr006aVl5U47'
}
// pre
if (__PRE__ || __TEST__) {
  tmp.BASE_URL = ''
  tmp.CORPORATION_MAIN_URL = 'http://b12013.camcard.com'
  tmp.CAMCARD_MAIN_URL = 'http://w12013.camcard.com'
  tmp.CORPORATION_STATIC_URL = 'http://static12013.intsig.net'
  tmp.FLOGGER_URL = 'https://web-ubd.intsig.net/'
  tmp.api_default = preApi
  tmp.UAPI = __TEST__ ? 'https://b12013.camcard.com' : ''
  tmp.env = 'pre'
  tmp.STRIPE_KEY =
    'pk_test_51JV5f5BlhvsvhMM2qdk3hOhY9x7UgJNfqERYJYVbQ8bkgUzm90nw9dpzDDHO4fMe175TZONfezMRm3vTcuk9dHCr006aVl5U47'
}
// online
if (__ONLINE__) {
  tmp.BASE_URL = ''
  tmp.CORPORATION_MAIN_URL = 'http://b.camcard.com'
  tmp.CAMCARD_MAIN_URL = 'http://www.camcard.com'
  tmp.CORPORATION_STATIC_URL = 'http://static.intsig.net'
  tmp.api_default = onlineApi
  tmp.FLOGGER_URL = 'https://web-ubd.intsig.net/'
  tmp.env = 'online'
  tmp.STRIPE_KEY =
    'pk_live_51JV5f5BlhvsvhMM2noA8bl4YiyR7INMk82eUYYvEUMW6j2emlYg8TTgR3MjB2tbCNBqDNkcYFCeATmcUmsPFH7BL00ldjYwO8s'
}
// 判断是否已有用户信息
const user_info = store.state.user.user_info
if (user_info && user_info.APIList) {
  for (const key in user_info.APIList) {
    tmp.api[key] = user_info.APIList[key][0]
  }
} else {
  tmp.api = Object.assign({}, tmp.api_default)
}

// let type = (store.state.user.user_info && store.state.user.user_info.group_id) || 'default';
// tmp.api = tmp.api[type] || tmp.api['default'];
export default Object.assign({}, shared, tmp)
